import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DialogService } from '../services/dialog.service';
import { APP_ROUTES } from '../constants/app-route.constants';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const dialogService = inject(DialogService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLoginPath = router.url.includes(APP_ROUTES.AUTH.LOGIN);

      if (error.status === 401 && !isLoginPath) {
        authService.logout();
        dialogService.warning(
          'Sesión expirada',
          'Por seguridad, su sesión ha expirado.',
        );
      }
      return throwError(() => error);
    }),
  );
};
